<template>
    <Button label="Importar do Sympla" icon="pi pi-download" class="ml-2" @click="abrirDialog()" />
    <Dialog header="Importar participante do Sympla" v-model:visible="mostrarDialog" :style="{ width: '30vw' }" :modal="true" @hide="reiniciar()">
        <div class="field">
            <label for="codigoSympla">Código de inscrição (Sympla)</label>
            <InputText id="codigoSympla" v-model="codigo" class="w-full" @keydown.enter="pesquisar()" :disabled="pesquisando || importando" />
        </div>

        <div v-if="pesquisado">
            <Message v-if="!preview || !preview.encontrado" :closable="false" severity="warn">
                {{ preview && preview.mensagem ? preview.mensagem : 'Código de inscrição não encontrado no Sympla.' }}
            </Message>
            <div v-else>
                <Message v-if="preview.jaImportado" :closable="false" severity="info">
                    {{ preview.mensagem || 'Este participante já foi importado para o evento.' }}
                </Message>
                <div class="mt-2">
                    <p><strong>Nome:</strong> {{ preview.nome }}</p>
                    <p><strong>E-mail:</strong> {{ preview.email }}</p>
                    <p><strong>CPF:</strong> {{ preview.cpf || '—' }}</p>
                    <p><strong>Código:</strong> {{ preview.codigoExterno }}</p>
                </div>
            </div>
        </div>

        <template #footer>
            <Button label="Fechar" icon="pi pi-times-circle" class="p-button-secondary" @click="fecharDialog()" />
            <Button label="Pesquisar" icon="pi pi-search" @click="pesquisar()" :disabled="!codigo || pesquisando || importando" />
            <Button
                label="Importar"
                icon="pi pi-download"
                @click="importar()"
                v-if="preview && preview.encontrado && !preview.jaImportado"
                :disabled="importando"
            />
        </template>
    </Dialog>
</template>

<script>
import ParticipantesServices from './services';

export default {
    props: {
        evento: {
            type: Object,
        },
    },

    emits: ['atualizar'],

    data() {
        return {
            mostrarDialog: false,
            codigo: null,
            preview: null,
            pesquisado: false,
            pesquisando: false,
            importando: false,
        };
    },

    methods: {
        abrirDialog() {
            this.mostrarDialog = true;
        },

        fecharDialog() {
            this.mostrarDialog = false;
            this.reiniciar();
        },

        reiniciar() {
            this.codigo = null;
            this.preview = null;
            this.pesquisado = false;
            this.pesquisando = false;
            this.importando = false;
        },

        pesquisar() {
            if (!this.codigo) return;
            this.pesquisando = true;
            this.$store.dispatch('addRequest');
            ParticipantesServices.pesquisarSymplaPorCodigo(this.evento.eventoId, this.codigo.trim())
                .then((response) => {
                    if (response?.success) {
                        this.preview = response.data;
                        this.pesquisado = true;
                    } else {
                        this.$toast.add({ severity: 'error', summary: 'Sympla', detail: response?.errors?.[0] || 'Erro ao pesquisar no Sympla', life: 3000 });
                    }
                })
                .finally(() => {
                    this.pesquisando = false;
                    this.$store.dispatch('removeRequest');
                });
        },

        importar() {
            this.importando = true;
            this.$store.dispatch('addRequest');
            ParticipantesServices.importarSymplaPorCodigo(this.evento.eventoId, this.codigo.trim())
                .then((response) => {
                    if (response?.success) {
                        this.$toast.add({ severity: 'success', summary: 'Sympla', detail: 'Participante importado com sucesso', life: 3000 });
                        this.$emit('atualizar');
                        this.fecharDialog();
                    } else {
                        this.$toast.add({ severity: 'error', summary: 'Sympla', detail: response?.errors?.[0] || 'Erro ao importar do Sympla', life: 4000 });
                    }
                })
                .finally(() => {
                    this.importando = false;
                    this.$store.dispatch('removeRequest');
                });
        },
    },
};
</script>
